<template>
  <div>
    <v-layout class="pb-16">
      <v-flex class="pr-30" xs12>
        <select-field
          v-model="form.eventCategoryId"
          :validator="vs.eventCategoryId"
          :items="categories"
          item-select="id"
          item-render="name"
          label="Category*"
          @change="onSelectedCategory"
        />
      </v-flex>
      <v-flex xs12>
        <select-field
          v-model="form.interests"
          :items="getSubCategories"
          item-select="id"
          item-render="name"
          :disabled="!form.eventCategoryId || !getSubCategories.length"
          :validator="vs.interests"
          label="Subcategory*"
          multiple
        />
      </v-flex>
    </v-layout>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.title"
        label="Event title*"
        :error-messages="{ maxLength: 'Title is limited to 120 characters.' }"
        autofocus
        :validator="vs.title"
      />
    </v-flex>
    <v-layout class="pb-16">
      <v-flex class="pr-30" xs12>
        <datetime-field
          v-model="form.from"
          :validator="vs.from"
          label="Starts*"
          :max="form.to ? form.to.toString() : null"
          :error-messages="{
            minDate: 'Start date must be a future date',
            maxDate: 'Start date should be before the end of the event',
          }"
        />
      </v-flex>
      <v-flex xs12>
        <datetime-field
          v-model="form.to"
          :validator="vs.to"
          label="Ends*"
          :min="
            form.from
              ? form.from.toString()
              : new Date(new Date().getTime() + 1000 * 60 * 5).toString()
          "
          :error-messages="{
            minDate: 'End date should not be before the start of the event',
          }"
        />
      </v-flex>
    </v-layout>
    <v-flex>
      <location-field v-model="form.location" :validator="vs.location" />
    </v-flex>
  </div>
</template>

<script>
export default {
  name: 'general-info-form',
  components: {},
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    categories: {
      type: Array,
      default: () => [],
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.initialValues,
    }
  },
  computed: {
    getSubCategories() {
      const selectedCategory = this.categories.find(c => c.id === this.form.eventCategoryId)

      if (!selectedCategory) {
        return []
      }

      return selectedCategory.subCategories || []
    },
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  methods: {
    onSelectedCategory() {
      this.form.interests = []
    },
  },
}
</script>

<style scoped>
@media (max-width: 800px) {
  .pb-16 {
    flex-direction: column;
  }

  .pr-30 {
    margin-right: 0 !important;
  }
}

@media (max-width: 800px) {
  .pb-8 {
    flex-direction: column;
    margin-bottom: 1rem;
  }

  .pr-30,
  .pr-30 + * {
    margin-right: 0 !important;
  }

  .pr-30 {
    margin-bottom: 1rem;
  }
}
</style>
